import { REMOVER_FILTRO_ROTA_ITINERARIO } from '../types'

export default function removerFiltroRotaItinerario (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_ROTA_ITINERARIO
  }
}
